:host {
  display: inline-flex;
  font-variation-settings: 'FILL' var(--omk-icon-fill);
  --md-icon-size: var(--omk-icon-size);
}
